import httpService from '../httpService';
import {
    DeviceDetailResponse,
    DeviceListResponse,
    DeviceListRequest,
    SingleDeassociateRequest,
    MultiDeassociateRequest,
    refreshDevicesResponse,
    RefreshDevicesRequest,
    HandleGetProductOptionsData,
    HandleGetProductOptionsResponse,
    SingleDeassociateResponse,
    MultiDeassociateResponse,
    PushDevicesResponse,
    DeviceLedRequest,
    DeviceLedResponse,
    TagLayoutDetailsResponse,
    PushDeviceRequest,
} from '@/types/pages/storeManagement/device';

import { APIResponse } from '@/types';

const getInitiator = (): string => `webpage|${window.location.href}`;

export function getDeviceDetail(mac: string): APIResponse<DeviceDetailResponse> {
    return httpService.get(`/device/${mac}`);
}

export function fetchDeviceList(
    corporationId: number,
    requestParams: DeviceListRequest,
    options?: { signal?: AbortSignal },
): APIResponse<DeviceListResponse> {
    return httpService.get(`/devices/list/${corporationId}`, {
        params: requestParams,
        signal: options?.signal,
    });
}

export const pushDevicesToProductsAPI = async (payload: PushDeviceRequest): APIResponse<PushDevicesResponse> => {
    return await httpService.post('/bond/associate', {
        ...payload,
        m2c_initiator: getInitiator(),
    });
};

export const setDevicesToLedMode = async (macAddresses: string[], led_cmd: string): APIResponse<DeviceLedResponse> => {
    const payload: DeviceLedRequest & { m2c_initiator: string } = {
        job_type: 'task',
        command: 'remote_command',
        devices: macAddresses,
        payload: led_cmd,
        m2c_initiator: getInitiator(),
    };

    const response = await httpService.put(`/devices/command`, payload);
    return response;
};

export const deassociateSingleDeviceAPI = async (mac: string): APIResponse<SingleDeassociateResponse> => {
    const payload: SingleDeassociateRequest & { m2c_initiator: string } = {
        job_type: 'task',
        command: 'deassociate',
        payload: '',
        m2c_initiator: getInitiator(),
    };

    const response = await httpService.put(`/device/command/${mac}`, payload);
    return response;
};

export const deassociateMultipleDevices = async (macAddresses: string[]): APIResponse<MultiDeassociateResponse> => {
    const payload: MultiDeassociateRequest & { m2c_initiator: string } = {
        job_type: 'task',
        command: 'deassociate',
        devices: macAddresses,
        m2c_initiator: getInitiator(),
    };

    const response = await httpService.put(`/devices/command`, payload);
    return response;
};

export const refreshDevicesAPI = async (data: RefreshDevicesRequest): APIResponse<refreshDevicesResponse> => {
    return httpService.put('/devices/command', {
        ...data,
        m2c_initiator: getInitiator(),
    });
};

export const handleGetProductOptionsAPI = async (
    cid: number,
    data: HandleGetProductOptionsData,
): APIResponse<HandleGetProductOptionsResponse> => {
    return httpService.post(`/products/search/${cid}`, data);
};

export const deleteDevicesAPI = async (storeId: number, macAddresses: string[]): APIResponse<void> => {
    const payload: {
        store_id: number;
        mac_address: string[];
        m2c_initiator: string;
    } = {
        store_id: storeId,
        mac_address: macAddresses,
        m2c_initiator: getInitiator(),
    };

    return await httpService.delete('/devices', {
        data: payload,
    });
};

export const removeAPorRTDevicesAPI = async (storeId: number, macAddresses: string[]) => {
    return httpService.delete('/devices/ap-rt', {
        data: {
            store_id: storeId,
            mac_address: macAddresses,
        },
    });
};

export const fetchTagLayoutDetailsAPI = async (
    storeId: number,
    macList: string[],
): APIResponse<TagLayoutDetailsResponse> => {
    return httpService.post('/bond/get_tag_info', {
        store_id: storeId,
        mac_address: macList,
    });
};

export const pushImageToDevicesAPI = async (
    macAddresses: string[],
    imgDataUrl: string, // e.g. "data:image/bmp;base64,...."
    // bpp: number,
): APIResponse<any> => {
    return httpService.put('/devices/command', {
        job_type: 'task',
        command: 'push_image',
        payload: {
            img_string: imgDataUrl,
            // bpp,
        },
        devices: macAddresses,
        m2c_initiator: getInitiator(),
    });
};

export const pushImageToSingleDeviceAPI = async (mac: string, imgDataUrl: string, bpp: number): APIResponse<any> => {
    return httpService.put(`/device/command/${mac}`, {
        job_type: 'task',
        command: 'push_image',
        payload: {
            img_string: imgDataUrl,
            bpp,
        },
        m2c_initiator: getInitiator(),
    });
};
